import { Container, Navbar, Dropdown } from "react-bootstrap"
import Logo from '../../assets/images/logo-sarva.png'
import avtar from '../../assets/images/default-avatar.jpg'
import { GoChevronDown } from "react-icons/go";
import { BiLogOutCircle } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
import WebService from "../../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import { resetState, updateProfileImage } from "../../Redux/action";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PiUserCircle } from "react-icons/pi";

const Header = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [id, setId] = useState("");
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        clearErrors,
        setError,
        watch,
    } = useForm();
    let watchVariable = watch();
    const [profileImage, setProfileImage] = useState(null);
    const userProfileImage = useSelector((state: any) => state?.profile?.profileImage) || null;
    
    const { t } = useTranslation();
    const [selectedRole, setSelectedRole] = useState({
        value: "selected_Role",
        label: "Select Role",
    })
    const [user, setUser] = useState<any>(null);

    useEffect(() => {
        getMeCall();
    }, []);


    const logout = () => {
        // navigate("/login");
        WebService.getAPI({
            action: `logout`,
            body: null,
            isShowError: true,
        })
            .then((res: any) => {
                dispatch(resetState());
                navigate("/login");
            })
            .catch(() => { });
    };

    const handleRedirectmyprofile = () => {
        navigate("/my-profile");
    };

    const getMeCall = () => {
        setLoader(true);
        WebService.getAPI({
            action: `me`,
        })
            .then((res: any) => {
                setUser(res.result);
                setId(res.result.id);
                setValue("userName", res.result.username);
                setValue("mobile", res.result.mobile_number);
                setValue("firstName", res.result.first_name);
                setValue("lastName", res.result.last_name);
                watchVariable.email = res.result.email;
                watchVariable.dial_code = res.result.dial_code;
                watchVariable.role = res.result.role;
                setValue("profileEmail", res.result.email);
                setValue("email", res.result.email);
                const roleId = res?.result?.role?.id;
                const role = { value: roleId, label: res?.result?.role?.role };
                setSelectedRole(role);
                setValue("role", role.label);
                setValue("roleId", role.value);
                setValue("dial_code", res.result.dial_code)
                setValue("country_code", res.result.country_code)
                setProfileImage(res?.result?.profile_image);
                watchVariable.profilePicture = res.profilePicture;
                setValue("profilePicture", res?.result?.profile_image);
                dispatch(updateProfileImage(res?.result?.profile_image));
                setLoader(false)
            })
            .catch((e) => {
                setLoader(false)
            });
    };

    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar expand="lg">
                        <Navbar.Brand className="me-5">
                            <img src={Logo} width={133} height={31} alt='' />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <div className="d-flex align-items-center ms-auto gap-3" >
                            <Dropdown className="profile-dd">
                                <Dropdown.Toggle>
                                    <div className='d-flex gap-2'>
                                        <div>
                                            <img
                                                src={
                                                    userProfileImage
                                                        ? userProfileImage
                                                        : avtar
                                                }
                                                width={35}
                                                height={35} className=" rounded-circle object-fit-cover" alt='' />
                                        </div>
                                        <div >
                                            <p className='font-14 mb-0 text-dark font-medium'>{user?.username}</p>
                                            <p className='font-12 mb-0 text-secondary'>{user?.email}</p>
                                        </div>
                                    </div>
                                    <GoChevronDown size={16} className='icon' />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                    <Dropdown.Item onClick={handleRedirectmyprofile}>
                                        <PiUserCircle className="me-2" />
                                        My Profile
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={logout}>
                                        <BiLogOutCircle className="me-2" />
                                        Logout
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Navbar>
                </Container>
            </header>
        </>
    )
}
export default Header;